<template>
  <BookGallery :year="2025" />
</template>

<script>
  import BookGallery from '../components/BookGallery';
  export default {
    name: 'HomePage',
    components: {
      BookGallery
    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/pages/HomePage.vue